
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/aalborg-surreal",
      function () {
        return require("private-next-pages/archive/aalborg-surreal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/aalborg-surreal"])
      });
    }
  